//
// FieldpickerMetadataField
//
// A fieldpicker-input.

import { observer } from 'mobx-react-lite'
import { useMousePopover } from '../../hooks/useMousePopover'
import { useStore } from '../../stores'

import { Icon, Item } from '../../components'
import { FieldpickerFieldMenu } from '../../menus'
import { IconTile } from '../../panels'
import { ItemTitle } from '../../workspaces/components'

export const FieldpickerMetadataField = observer(
    function FieldpickerMetadataField(props) {
        const {
            className,
            field,
            fieldname,
            fieldpath,
            item,
            language,
            renderkey,
            onChange,
            ...other
        } = props

        const { data, view } = useStore()

        const FieldpickerFieldContextMenu = useMousePopover(FieldpickerFieldMenu)

        let classes = 'cc-Field cc-FieldpickerField cc-FieldpickerMetadataField'
        if (className) classes += ' ' + className

        const fieldvalue = field.is_localized ? field.value[language] : field.value

        const linkedfieldgids =
            fieldvalue && fieldvalue.split ? fieldvalue.split(/\./) : []
        const linkedfield =
            fieldvalue && data.fields.has(linkedfieldgids[0])
                ? data.fields.get(linkedfieldgids[0])
                : undefined

        const fromFieldsMap = new Map(
            data.fields.values().map(field => [field.gid, field])
        )

        const onAddField = (linkedfield, otherfieldgid) => {
            const metadatafield = item.metadata.get(fieldpath)
            item.setMetadataField(
                fieldpath,
                metadatafield.type,
                metadatafield.is_localized,
                otherfieldgid,
                language
            )
            onChange && onChange(item)
        }

        const onReplaceField = (linkedfield, otherfieldgid) => {
            const metadatafield = item.metadata.get(fieldpath)
            item.setMetadataField(
                fieldpath,
                metadatafield.type,
                metadatafield.is_localized,
                otherfieldgid,
                language
            )
            onChange && onChange(item)
        }

        const onRemoveField = linkedfield => {
            const metadatafield = item.metadata.get(fieldpath)
            item.setMetadataField(
                fieldpath,
                metadatafield.type,
                metadatafield.is_localized,
                null,
                language
            )
            onChange && onChange(item)
        }

        const onRevealInSchema = linkedfield => {
            view.schemaworksheet.setItem(linkedfield)
            view.schematree.datamanager.setItem(linkedfield)
            view.setWorkspace('schema')
        }

        const onFieldpickerFieldAction = (action, linkedfield, otherfieldgid) => {
            const actions = {
                add_field: onAddField,
                replace_field: onReplaceField,
                remove_field: onRemoveField,
                reveal_in_schema: onRevealInSchema,
            }
            if (!(action in actions)) {
                console.log(`onFieldpickerFieldAction: unhandled action '${action}'`)
                return
            }
            FieldpickerFieldContextMenu.hide()
            actions[action](linkedfield, otherfieldgid)
        }

        const onShowFieldpickerFieldMenu = e => {
            FieldpickerFieldContextMenu.onShow(e)
        }

        const icontileanchor = 'left'
        const iconplaceholder = 'plus'

        const subfieldtitles = linkedfieldgids.map((linkedfieldgid, index) => {
            const subfield = data.fields.get(linkedfieldgid)
            return (
                <Item key={index} indent={2 * index}>
                    <Icon name="field" size="text" />{' '}
                    <ItemTitle item={subfield} ellipsisAfter={32} />
                </Item>
            )
        })

        return (
            <div className={classes} {...other}>
                <FieldpickerFieldContextMenu.Panel
                    fromFields={fromFieldsMap}
                    linkedfield={linkedfield}
                    onAction={onFieldpickerFieldAction}
                    action="set"
                />
                {!linkedfield ? (
                    <IconTile
                        width={20}
                        className="cc-dimmed"
                        icon={iconplaceholder}
                        anchor={icontileanchor}
                        onClick={onShowFieldpickerFieldMenu}
                    />
                ) : (
                    <Item
                        onClick={onShowFieldpickerFieldMenu}
                        onContextMenu={onShowFieldpickerFieldMenu}
                    >
                        {subfieldtitles}
                    </Item>
                )}
            </div>
        )
    }
)
